<script setup lang="ts">
import { ChevronRight, Home } from 'lucide-vue-next';
import { useBreadcrumbs } from '@/shared/composables/useBreadcrumbs';
import { Icon } from '@tms-phoenix/ui-vue';

const { breadcrumbs } = useBreadcrumbs();
</script>

<template>
  <nav
    class="flex"
    aria-label="Breadcrumb"
  >
    <ol class="flex items-center space-x-1">
      <li
        v-for="(item, index) in breadcrumbs"
        :key="index"
        class="flex items-center"
      >
        <!-- Separator -->
        <ChevronRight
          v-if="index > 0"
          class="mr-2 h-4 w-4 flex-shrink-0 text-gray-400"
          aria-hidden="true"
        />

        <!-- Breadcrumb item -->
        <RouterLink
          v-if="item.to"
          :to="item.to"
          class="flex items-center text-sm font-medium text-primary hover:text-gray-700"
        >
          <!-- <Home
            v-if="index === 0"
            class="mr-1.5 h-4 w-4 flex-shrink-0"
            aria-hidden="true"
          /> -->
          <Icon
            v-if="index === 0"
            size-class="mr-1.5 h-4 w-4 flex-shrink-0"
            color="text-primary-600"
            name="Home"
          />
          <component
            :is="item.icon"
            v-else-if="item.icon"
            class="mr-1.5 h-4 w-4 flex-shrink-0"
            aria-hidden="true"
          />
          {{ item.label }}
        </RouterLink>

        <!-- Current page (not a link) -->
        <span
          v-else
          class="flex items-center text-sm font-medium text-gray-500"
          aria-current="page"
        >
          <Home
            v-if="index === 0"
            class="mr-1.5 h-4 w-4 flex-shrink-0"
            aria-hidden="true"
          />
          <component
            :is="item.icon"
            v-else-if="item.icon"
            class="mr-1.5 h-4 w-4 flex-shrink-0"
            aria-hidden="true"
          />
          {{ item.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>
